import { render, staticRenderFns } from "./PriceLockForm.vue?vue&type=template&id=be18951c&scoped=true&"
import script from "./PriceLockForm.vue?vue&type=script&lang=js&"
export * from "./PriceLockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be18951c",
  null
  
)

export default component.exports